import * as React from 'react';

export function NewsIconSvg() {
  return (
    <svg height="20px" version="1.1" viewBox="0 0 25 20" width="25px">
      <title>news</title>
      <g
        id="Hi-Fi"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="1"
          transform="translate(-209.000000, -463.000000)"
          fill="currentColor"
        >
          <g id="Group-12" transform="translate(209.000000, 463.000000)">
            <path
              d="M23.6110197,16.6703606 C23.6110197,18.715431 21.9997521,18.7774028 21.8758085,18.7774028 C21.0701746,18.7774028 20.6989634,17.7238817 20.6989634,16.6703606 L20.6989634,3.59430423 L22.8053859,3.59430423 C23.5490479,3.59430423 23.6110197,4.21402254 23.6110197,4.39993803 L23.6110197,16.6703606 Z M2.66454085,18.7774028 C2.35468169,18.7774028 1.17783662,18.5295155 1.17783662,17.2900789 L1.17783662,1.05345915 L19.7067944,1.05345915 L19.7067944,1.92106479 L19.7067944,16.7323324 C19.7067944,17.4759944 19.8927099,18.2816282 20.2651606,18.8393746 L2.66454085,18.8393746 L2.66454085,18.7774028 Z M22.8053859,2.66472676 L20.6989634,2.66472676 L20.6989634,0.0619098592 L0.309611268,0.0619098592 L0.309611268,17.3520507 C0.309611268,19.0252901 1.73496338,19.7689521 2.72713239,19.7689521 L22.1856676,19.7689521 C22.9913014,19.7689521 24.6031887,19.2731775 24.6031887,17.3520507 L24.6031887,4.46190986 C24.5405972,3.71824789 24.0448225,2.66472676 22.8053859,2.66472676 L22.8053859,2.66472676 Z"
              id="Fill-3"
            />
            <polygon
              id="Fill-5"
              points="4.4 5.26760563 16.4225352 5.26760563 16.4225352 3.90422535 4.4 3.90422535"
            />
            <polygon
              id="Fill-7"
              points="4.4 7.93239437 16.4225352 7.93239437 16.4225352 6.56901408 4.4 6.56901408"
            />
            <polygon
              id="Fill-8"
              points="4.4 15.9887324 5.63943662 15.9887324 5.63943662 9.29577465 4.4 9.29577465"
            />
            <polygon
              id="Fill-9"
              points="7.74647887 13.2619718 16.4225352 13.2619718 16.4225352 11.8985915 7.74647887 11.8985915"
            />
            <polygon
              id="Fill-10"
              points="7.74647887 15.9267606 16.4225352 15.9267606 16.4225352 14.5633803 7.74647887 14.5633803"
            />
            <polygon
              id="Fill-11"
              points="7.74647887 10.5971831 16.4225352 10.5971831 16.4225352 9.23380282 7.74647887 9.23380282"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
